module.exports = __webpack_public_path__ + "static/media/user.425d5b7a.svg";